import { Spacing } from "../../../foundations/spacing.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
const accordionSummaryStyleOverrides = {
  root: {
    display: Displaying.flex,
    padding: Spacing["0"],
    ".MuiAccordionSummary-content": {
      display: Displaying.flex,
      flexDirection: Direction.row,
      gap: `0 ${Spacing["500"]}`,
      margin: 0,
      alignItems: Alignment.center,
      wordBreak: "break-all"
    },
    ".MuiTypography-root": {
      lineHeight: Spacing["1500"],
      display: Displaying.flex
    },
    "#accordion-icon": {
      paddingLeft: 0
    }
  }
};
export {
  accordionSummaryStyleOverrides
};
//# sourceMappingURL=accordion-summary.es.js.map
